namespace Roodik.Core
{
	"use strict"
	
	export class StorageManager implements IStorageManager
	{
		private _allowLocalStorage : boolean;
		
		constructor(private _gameID : string)
		{
			this._allowLocalStorage = true;
		}
		
		public loadData(key)
		{
			key = this._gameID + key;
			if(this._allowLocalStorage)
			{
				try
				{
					var data = localStorage.getItem(key);
					if(data)
					{
						return JSON.parse(data);
					}
				}
				catch(error)
				{
					this._allowLocalStorage = false;
				}
			}
			return null;
		}
		
		public saveData(key, value)
		{
			key = this._gameID + key;
			value = JSON.stringify(value);
			
			if(this._allowLocalStorage)
			{
				try
				{
					localStorage.setItem(key, value);
					return true;
				}
				catch(error)
				{
					this._allowLocalStorage = false;
					return false; // Saving failed!
				}
			}
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Storage/StorageManager.ts